export default __webpack_public_path__ + "static/media/pro_aim_tetris.782710c3.png";